module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder-symlink-fill-0ebf1cb0.svg";